const EsBenefEfectDelCobroOptions = [
  {
    label: "Selecciona",
    value: '',
  },
  {
    label: "SI",
    value: "SI",
  },
  {
    label: "NO",
    value: "NO",
  }
];

export default EsBenefEfectDelCobroOptions;